import axios from 'axios';
import * as L from "leaflet";
import Popup from 'reactjs-popup';
import Logo from './logo.png';
import React, { useEffect, useRef, useState } from 'react';
import {
    COUNTRY_CODE_URL,
    EVENT_ASSOCIATE_URL,
    EVENT_FORMAT_URL,
    EVENT_LAST_VISIT_URL,
    EVENT_TYPE_URL,
    GET_SITECODES,
    SITES_BASE_URL,
    EVENT_ALL_ACTIVE_USERS_URL,
    EVENT_CHANGE_REQUESTOR
} from '../ApiDetails.js';
import '../GetEvent.jsx/Event.css';
import useFormContext from "./useFormAdminContext.js";
import { OpenStreetMapProvider } from 'leaflet-geosearch';

const EventAdmin = ({ isEditing }) => {
    const {
        errors,
        handleEmailValidation,
        eventFormData,
        setEventFormData,
        comments,
        setComments,
        addCommentsEventSection,
        editable,
        handleMLTEventChange,
        searchAddress, setSearchAddress,
        isEventOffSite, setIsEventOffSite,
        associateAtEvent, setassociateAtEvent,
        selectedAssociates, setSelectedAssociates
    } = useFormContext()

    const [mapMarker, setMapMarker] = useState(null);
    const leafLetMap = useRef(null);
    const [timer, setTimer] = useState(null);

    const [eventType, setEventTypes] = useState([]);
    const [siteCode, setSiteCodes] = useState([]); // Ensure it's initialized as an array
    const [eventFormat, setEventFormat] = useState([]);
    const [lastVisit, setlastVisit] = useState([]);
    const [phoneCode, setphoneCode] = useState([]);
    var city = "";
    if (eventFormData.cityName != null) city = eventFormData.cityName;
    if (eventFormData.stateName != null) {
        city = city + (city != "" ? ", " : "") + eventFormData.stateName;
    }
  
    const [newRequestorId, setNewRequestorId] = useState(null);
    const [userSearch, setUserSearch] = useState("");

    const isFirstRender = useRef(true);
    const storedRole = localStorage.getItem('role');

    const [users, setUsers] = useState([])
    const fetchUsers = async () => {
        try {
            const response = await axios.get(EVENT_ALL_ACTIVE_USERS_URL);
            setUsers(response.data);
        } catch (error) {
            console.error('Error fetching event types:', error);
        }
    };

    useEffect(() => {
        var u = window.location.href.split("/")[3];
        if (u !== "getDetail") {
            if (isFirstRender.current) {
                loadInitMap();
            }
            isFirstRender.current = false;
        }

        if (editable) {
            var elementArray = document.getElementsByClassName("editable")
            for (var i = 0; i < elementArray.length; i++) {
                if (elementArray[i]) {
                    elementArray[i].hidden = false;
                }
            }

        }
        else {
            var elementArray2 = document.getElementsByClassName("editable")
            for (var j = 0; j < elementArray2.length; j++) {
                if (elementArray2[j]) {
                    elementArray2[j].hidden = true;
                }
            }
        }
        if (eventFormData.siteCode === "OFF") {
            setSearchAddress(eventFormData.eventAddress);
        }
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const [
                    phoneResponse,
                    fetchSiteCodesResponse,
                    eventTypesResponse,
                    eventFormatResponse,
                    lastVisitResponse,
                    associateAtEventResponse
                ] = await Promise.all([
                    axios.get(COUNTRY_CODE_URL),
                    axios.get(GET_SITECODES),
                    axios.get(EVENT_TYPE_URL),
                    axios.get(EVENT_FORMAT_URL),
                    axios.get(EVENT_LAST_VISIT_URL),
                    axios.get(EVENT_ASSOCIATE_URL)
                ]);

                // Set the data into your state once all promises resolve
                setphoneCode(phoneResponse.data);
                setEventTypes(eventTypesResponse.data);
                setSiteCodes(fetchSiteCodesResponse.data);
                setEventFormat(eventFormatResponse.data);
                setlastVisit(lastVisitResponse.data);
                setassociateAtEvent(associateAtEventResponse.data);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchUsers();
        fetchData(); // Run the fetch operation when the component is mounted
        // If new event, set status to Draft by default
        if (typeof eventFormData.eventStatus === "undefined") {
            setEventFormData(prevData => ({ ...prevData, eventStatus: 'Draft' }));
        }
    }, []); // Empty dependency array to run only once on mount

    const associateMapping = {
        "Corporate": "marsCorporateAttendees",
        "Food & Nutrition & Multisales": "marsFoodNutritionAttendees",
        "Mars Global Services": "marsGlobalServicesAttendees",
        "Multisales": "marsMultisalesAttendees",
        "Snacking": "marsSnackingAttendees",
        "Petcare": "marPetCareAttendees",
        "Veterinary Health": "marsVeterinaryHealthAttendees",
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEventFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const rebuildCurrentSiteAddress = () => {
        var address = eventFormData.eventAddress;
        address = address.replace("\n", " ");
        if (eventFormData.eventVenueName) address = eventFormData.eventVenueName + ", " + address;
        if (eventFormData.cityName) address = address + ", " + eventFormData.cityName;
        if (eventFormData.stateName) address = address + ", " + eventFormData.stateName;
        if (eventFormData.countryName) address = address + ", " + eventFormData.countryName;
        return address;
    };

    const handleSearchAddressChange = async (e) => {
        var address = e.target.value;
        setSearchAddress(e.target.value);
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                setSearchAddress(address);
                fetchAddressCoordinates(address);
            }, 500)
        );
    }

    const handleOffSiteChange = async (e) => {
        setIsEventOffSite(e.target.checked);
        if (e.target.checked) {
            var address = searchAddress;
            if (address === "") {
                address = rebuildCurrentSiteAddress();
                setSearchAddress(address);
            }

            fetchAddressCoordinates(address);
        }
        else {
            fetchCityCoordinates(eventFormData.siteCode);
        }
    };

    const handleSiteCodeChange = async (e) => {
        const siteCode = e.target.value;
        setEventFormData((prevData) => ({
            ...prevData,
            siteCode: siteCode, // update the siteCode in form data
        }));

        // Fetch data based on the new siteCode
        try {
            const response = await axios.get(`${SITES_BASE_URL}/${siteCode}`);

            // Assuming the API returns country, stateName, cityName, eventVenueName, eventAddress
            const { country, location: stateName, city: cityName, unit: eventVenueName, address: eventAddress } = response.data;

            // Update form data with the fetched values
            setEventFormData((prevData) => ({
                ...prevData,
                countryName: country ?? prevData.countryName,
                stateName: stateName ?? prevData.stateName,
                cityName: cityName ?? prevData.cityName,
                eventVenueName: eventVenueName ?? prevData.eventVenueName,
                eventAddress: eventAddress ?? prevData.eventAddress,
            }));
        } catch (error) {
            console.error("Error fetching site details:", error);
        }
    };

    const handleCheckboxChange = (e, value) => {
        const checked = e.target.checked;

        setSelectedAssociates(prevSelectedAssociates => {
            const updatedSet = new Set(prevSelectedAssociates);
            if (checked) {
                updatedSet.add(value);
            } else {
                updatedSet.delete(value);
            }
            return updatedSet;
        });
    };


    useEffect(() => {
        if (eventFormData.siteCode) {
            setIsEventOffSite(eventFormData.siteCode === "OFF");
            if (eventFormData.siteCode === "OFF")
                fetchAddressCoordinates(eventFormData.eventAddress);
            else
                fetchCityCoordinates(eventFormData.siteCode);
        }
    }, [eventFormData.siteCode]);

    const loadInitMap = async () => {
        if (!leafLetMap.current) {
            leafLetMap.current = L.map(document.getElementById("MapID"));
            leafLetMap.current.invalidateSize();
        }

        L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);
    }

    const fetchCityCoordinates = async (siteCode) => {
        try {

            const response = await axios.get(`${SITES_BASE_URL}/${siteCode}`);

            // Check if the response contains valid data
            if (response.data) {
                const { latitude, longitude, unit, location, address, country, city } = response.data;

                if (!leafLetMap.current) {
                    leafLetMap.current = L.map(document.getElementById("MapID"));
                    leafLetMap.current.invalidateSize();
                }

                leafLetMap.current.setView([latitude, longitude], 14);
                L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

                L.Icon.Default.mergeOptions({
                    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
                    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
                    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
                });

                if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
                setMapMarker(null);
                var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
                setMapMarker(marker);

                setEventFormData(prevData => ({
                    ...prevData,
                    eventVenueName: unit ?? prevData.eventVenueName,
                    eventAddress: address ?? prevData.eventAddress,
                    countryName: country ?? prevData.countryName,
                    stateName: location ?? prevData.stateName,
                    cityName: city ?? prevData.cityName,
                    mltEvent: storedRole === "MLTUser" ? true : eventFormData.mltEvent
                }));
            } else {
                console.error("No data found for the specified site code.");
            }
        } catch (error) {
            console.error("Error fetching site coordinates:", error);
        }
    };

    const fetchAddressCoordinates = async (address) => {
        const provider = new OpenStreetMapProvider();
        const results = await provider.search({ query: address });
        if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
        setMapMarker(null);
        if (!results[0]) {
            leafLetMap.current.setView([0, 0], 14);
            return;
        }
        const latitude = results[0].y;
        const longitude = results[0].x;

        if (!leafLetMap.current) {
            leafLetMap.current = L.map(document.getElementById("MapID"));
            leafLetMap.current.invalidateSize();
        }

        leafLetMap.current.setView([latitude, longitude], 14);
        L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

        L.Icon.Default.mergeOptions({
            iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
            iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
            shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        });

        var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
        setMapMarker(marker);
    };

    const handleChangeRequestor = () => {
        axios.get(EVENT_CHANGE_REQUESTOR+"/"+eventFormData.eventId+"/"+newRequestorId)
          .catch(function (error) {
                alert("Error, the requestor was not changed.");
            })
           .then( function () {
               alert("Requestor was changed.");
           });
           setNewRequestorId(null); 
    }

    const content = (
        <>
            <div className="col-md-6">
                <div className=" bg-light rounded p-3 ">


                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            REQUESTED BY
                        </label>
                        <div className="col-sm-4 ">

                            <input
                                type="text"
                                readOnly={true}
                                className="custom-font-lt form-control-plaintext disabled"
                                id="requestedBy"
                                name="requestedBy"
                                value={eventFormData.requestedBy || ''}
                                placeholder="Not Applicable"
                                autoComplete="off"
                            />
                        </div>
                        <div className="col-sm-4 ">
                        {newRequestorId && (
                                <button type="button" id="btnChangeRequestor" className="btn btn-outline-primary right-buttons"
                                        style={{color:"red", borderColor:"red",fontSize:"8pt"}}
                                  onClick={(e) => handleChangeRequestor(e)}
                                >
                                  Confirm requestor change
                                </button>
                        )}
                        <Popup
                          trigger={
                                    <button type="button" id="btnChangeRequestor" className="btn btn-outline-primary right-buttons"
                                            style={(newRequestorId===null) ? {color:"black", borderColor:"black",fontSize:"8pt"} : {display:"none", color:"black", borderColor:"black",fontSize:"8pt"}}
                                        onClick={(e) => { e.preventDefault(); }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="black" width="16" height="16" viewBox="0 0 24 24" >
                                        <path d="M21.7,4.3l-2-2c-0.4-0.4-1-0.4-1.4,0L8,12.6c-0.2,0.2-0.4,0.5-0.5,0.8L6,18c-0.1,0.4,0,0.9,0.3,1.2c0.3,0.3,0.8,0.4,1.2,0.3 l4.6-1.5c0.3-0.1,0.6-0.3,0.8-0.5l10.3-10.3C22.1,5.3,22.1,4.7,21.7,4.3z M8.4,17.2L7.5,16.3l0.7-2.2l5.7-5.7l2,2L8.4,17.2z M18.3,7.3l-2-2l1-1l2,2L18.3,7.3z" />
                                        </svg>&nbsp;Change requestor
                                    </button>
                                }
                          position="right center"
                          arrow={false}
                          onClose={() => setUserSearch("")}
                          onOpen={() => document.getElementById("searchUserText").focus() }
                        >
                          <div className="popup" id="userPopup" style={{ position: 'fixed', top: '50%', left: '50%', width: '25%', height: '75%'}}>
                            <div className="container-fluid justify-content-between">
                              <div className="d-flex align-items-center">
                                <a className="navbar-brand mb-0" href="#">
                                  <img src={Logo} alt="Logo" width="100" className="d-inline-block align-text-top" />
                                </a>
                                <a
                                  className="close-btn"
                                  style={{ textDecoration: 'none' }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setUserSearch("");
                                    document.getElementById('userPopup').style.display = 'none';
                                  }}
                                >x</a>
                            </div>
                            </div>
                                <input style={{ height: 32, width:"100%" }}
                                  type="text"
                                  id="searchUserText"
                                  value={userSearch}
                                  onChange={ (e) => {setUserSearch(e.target.value);} }
                                  placeholder={"Search any user"}
                                />
                            <div className="content" style={{ height: "90%", overflowY: 'scroll'  }}>
                              {users.map((user) => { if ((user.fullname.toLowerCase().includes(userSearch.toLowerCase())) || (userSearch.toLowerCase()==="")) 
                              return (
                                <div className="guest-item" key={user.id}>
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setEventFormData(prevData => ({ ...prevData, requestedBy: user.fullname, email:user.email }));
                                      setNewRequestorId(user.id);
                                      setUserSearch("");
                                      document.getElementById('userPopup').style.display = 'none';
                                    }}
                                  >
                                    {user.fullname}
                                  </a>
                                  <br />
                                </div>
                              )})}
                            </div>
                          </div>
                        </Popup>
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            EVENT TITLE
                        </label>
                        <div className="col-sm-8 ">
                            <input
                                type="text"
                                className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                id="staticEmail"
                                name="eventTitle"
                                readOnly={!isEditing}
                                onChange={handleInputChange}
                                value={eventFormData.eventTitle || ''}
                                placeholder="Not Applicable"
                            />
                            {errors.eventTitle && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventTitle}</div>}
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            ASSOCIATE&apos;S SEGMENT
                        </label>
                        <div className="col-sm-8 ">
                            <input
                                type="text"
                                readOnly={!isEditing}
                                onChange={handleInputChange}
                                className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                id="staticEmail"
                                name="associateSegment"
                                value={eventFormData.associateSegment || ''}
                                placeholder="Not Applicable"
                            />
                            {errors.associateSegment && <div style={{ color: 'red', fontSize: "13px" }}>{errors.associateSegment}</div>}
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label disabled"
                        >
                            E-MAIL
                        </label>
                        <div className="col-sm-8 ">
                            <input
                                type="text"
                                readOnly={true}
                                className="custom-font-lt form-control-plaintext disabled"
                                id="staticEmail"
                                name="email"
                                value={eventFormData.email || ''}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            PHONE
                        </label>
                        <div className="col-sm-8 ">
                            <div className="row">
                                <div className="col-3">
                                    {isEditing ? (
                                        <select className="custom-font-lt form-control">
                                            <option aria-placeholder={+91}>+91</option>
                                            {phoneCode.map((phoneCode, index) => (
                                                <option key={index} value={phoneCode}>{phoneCode}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <div className="custom-font-lt form-control-plaintext">
                                            {eventFormData.phoneCode}
                                        </div>
                                    )}
                                    {errors.phoneCode && <div style={{ color: 'red', fontSize: "13px" }}>{errors.phoneCode}</div>}
                                </div>
                                <div className="col-sm-8">
                                    <input
                                        type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        id="staticEmail"
                                        name="phone"
                                        value={eventFormData.phone || ''}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                        placeholder={!isEditing ? "" : "Enter a phone number"}
                                    />
                                    {errors.phone && <div style={{ color: 'red', fontSize: "13px" }}>{errors.phone}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            EVENT CO-HOST NAME <embed />
                            Optional
                            <embed />
                        </label>
                        <div className="col-sm-8 ">
                            <input
                                type="text"
                                className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                id="staticEmail"
                                name="eventCoHost"
                                value={eventFormData.eventCoHost || ''}
                                placeholder={!isEditing ? "" : "Enter a name"}
                                autoComplete="off"
                                readOnly={!isEditing}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            EVENT CO-HOST EMAIL <embed />
                            Optional
                            <embed />
                        </label>
                        <div className="col-sm-8 ">
                            <input
                                type="text"
                                className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                id="staticEmail"
                                name="coHostEmail"
                                value={eventFormData.coHostEmail || ''}
                                placeholder={!isEditing ? "" : "Enter an email"}
                                readOnly={!isEditing}
                                onChange={handleInputChange}
                                onBlur={handleEmailValidation}
                            />
                            {errors.coHostEmail && (
                                <div style={{ color: 'red', fontSize: "13px" }}>
                                    {errors.coHostEmail}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            MLT EVENT
                        </label>
                        <div className="col-sm-8 ">
                            <div className="custom-control custom-switch">
                                <span className="custom-font-slider-left" style={(!isEditing) ? {marginLeft:"10px"} : {}}>NO</span>
                                <input
                                    type="hidden"
                                    className="custom-control-input"
                                />
                                <label className="switch">
                                    <input type="checkbox" name="mltEvent"
                                        checked={eventFormData.mltEvent || false}
                                        readOnly={!isEditing}
                                        onChange={(e) => {
                                            if (eventFormData.mltEvent) {
                                                handleMLTEventChange(e);
                                            }
                                        }}
                                        disabled={(eventFormData.eventStatus !== 'Draft') && (!isEditing)}
                                    />
                                    <span className="slider round" />
                                </label>
                                {errors.mltEvent && (
                                    <div style={{ color: 'red', fontSize: '13px' }}>
                                        {errors.mltEvent}
                                    </div>
                                )}
                                <span className="custom-font-slider-right">YES</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="bg-light rounded p-3 mt-3">
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            EVENT DATE
                        </label>
                        <div className="col-sm-8 d-flex align-items-center">
                            {isEditing ? (
                                <>
                                    <input
                                        type="date"
                                        className="form-control-custom rounded form-control col-5"
                                        id="eventDate"
                                        name="eventDate"
                                        placeholder={!isEditing ? "" : "Pick event dates"}
                                        value={eventFormData.eventDate == '' ? '' : new Date(eventFormData.eventDate).toISOString().split("T")[0]}
                                        onChange={handleInputChange}
                                        style={{ "-webkit-calendar-picker-indicator": "100vh", width: "50%" }}
                                    />
                                    {errors.eventDate && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventDate}</div>}
                                    to
                                    <input
                                        type="date"
                                        className="form-control-custom rounded form-control col-5"
                                        id="eventEndDate"
                                        name="eventEndDate"
                                        placeholder={!isEditing ? "" : "Pick end date"}
                                        min={eventFormData.eventDate == '' ? '' : new Date(eventFormData.eventDate).toISOString().split("T")[0]}
                                        value={eventFormData.eventEndDate == '' ? '' : new Date(eventFormData.eventEndDate).toISOString().split("T")[0]}
                                        onChange={handleInputChange}
                                        style={{ "-webkit-calendar-picker-indicator": "100vh", width: "50%" }}
                                    />
                                    {errors.eventEndDate && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventEndDate}</div>}
                                </>
                            ) : (
                                <>
                                    <input
                                        type="text"
                                        className="custom-font-lt form-control-plaintext disabled col-5"
                                        name="eventDate"
                                        value={new Date(eventFormData.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'}) || ''}
                                        readOnly={true}
                                        style={{ "-webkit-calendar-picker-indicator": "100vh", width: "50%" }}
                                    />
                                    to
                                    <input
                                        type="text"
                                        className="custom-font-lt form-control-plaintext disabled col-5"
                                        name="eventEndDate"
                                        value={new Date(eventFormData.eventEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'}) || ''}
                                        readOnly={true}
                                        style={{ "-webkit-calendar-picker-indicator": "100vh", width: "50%" }}
                                    />
                                </>
                            )}
                        </div>
                    </div>

                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            IS THE EVENT DATE FLEXIBLE?
                        </label>
                        <div className="col-sm-8 ">
                            <div className="custom-control custom-switch">
                                <span className="custom-font-slider-left" style={(!isEditing) ? {marginLeft:"10px"} : {}}>NO</span>
                                <input
                                    type="hidden"
                                    className="custom-control-input"
                                    id="switch1"

                                />
                                <label className="switch">
                                    <input type="checkbox" name="isDateFlexible"
                                        checked={eventFormData.isDateFlexible || false}
                                        readOnly={!isEditing} />
                                    <span className="slider round" />
                                </label>
                                {errors.isDateFlexible && <div style={{ color: 'red', fontSize: "13px" }}>{errors.isDateFlexible}</div>}
                                <span className="custom-font-slider-right">YES</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" bg-light rounded p-3 mt-3">

                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >EXTERNAL EVENT</label>
                        <div className="col-sm-8 ">
                            <div className="custom-control custom-switch">
                                <span className="custom-font-slider-left" style={(!isEditing) ? {marginLeft:"10px"} : {}}>NO</span>
                                <input
                                    type="hidden"
                                    className="custom-control-input"
                                    id="switch1"
                                />
                                <label className="switch">
                                    <input type="checkbox" id="isOffSite"
                                        checked={isEventOffSite}
                                        onChange={handleOffSiteChange}
                                        disabled={!isEditing}
                                    />
                                    <span className="slider round" />
                                </label>
                                <span className="custom-font-slider-right">YES</span>
                            </div>
                        </div>
                    </div>
                    {(!isEventOffSite) && (
                        <>
                            <div className="form-group row mb-2">
                                <label
                                    htmlFor="staticEmail"
                                    className="custom-font col-sm-4 col-form-label"
                                >
                                    AFFILIATED SITE CODE
                                </label>
                                <div className="col-sm-8 ">
                                    {isEditing ? (
                                        <select className="custom-font-lt form-control form-select form-select-sm" aria-label="Small select example" name="siteCode" value={eventFormData.siteCode || ''} onChange={handleSiteCodeChange} >
                                            <option value="">Select a Format</option>
                                            {siteCode.map((siteCode, index) => (
                                                <option key={index} value={siteCode}>{siteCode}</option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type="text"
                                            className="custom-font-lt form-control-plaintext disabled"
                                            id="staticSiteCode"
                                            name="siteCode"
                                            value={eventFormData.siteCode || ''}
                                            placeholder="Not Applicable"
                                            readOnly={true}
                                        />
                                    )}
                                    {errors.siteCode && <div style={{ color: 'red', fontSize: "13px" }}>{errors.siteCode}</div>}
                                </div>
                            </div>
                            <div className="form-group row mb-2" hidden>
                                <label
                                    htmlFor="staticEmail"
                                    className="border-custom-strip custom-font col-sm-4 col-form-label"
                                >
                                    <div className=""> PLEASE SPECIFY</div>
                                </label>
                                <div className="col-sm-8 ">
                                    <input
                                        type="text"
                                        className="custom-font-lt form-control-plaintext disabled"
                                        id="staticEmail"
                                        placeholder="Not Applicable"
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mb-2">
                                <label
                                    htmlFor="staticEmail"
                                    className="custom-font col-sm-4 col-form-label"
                                >
                                    COUNTRY
                                </label>
                                <div className="col-sm-8 ">
                                    <input
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        aria-label="Small select example"
                                        name="countryName"
                                        value={eventFormData.countryName || ''}
                                        readOnly={!isEditing}
                                        disabled={!isEventOffSite}
                                    />
                                </div>
                            </div>
                            <div className="form-group row mb-2">
                                <label
                                    htmlFor="staticEmail"
                                    className="custom-font col-sm-4 col-form-label"
                                >
                                    STATE
                                </label>
                                <div className="col-sm-8 ">
                                    <div className="col-sm-6">
                                      <input
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        name="stateName"
                                        value={eventFormData.stateName}
                                        readOnly={!isEditing}
                                        disabled={!isEventOffSite}
                                      />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row mb-2">
                                <label
                                    htmlFor="staticEmail"
                                    className="custom-font col-sm-4 col-form-label"
                                >
                                    CITY
                                </label>
                                <div className="col-sm-8 ">
                                    <div className="col-sm-6">
                                      <input
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        name="cityName"
                                        id="cityName"
                                        value={eventFormData.cityName}
                                        readOnly={!isEditing}
                                        disabled={!isEventOffSite}
                                      />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row mb-2">
                                <label
                                    htmlFor="staticEmail"
                                    className="custom-font col-sm-4 col-form-label"
                                >
                                    EVENT VENUE NAME
                                </label>
                                <div className="col-sm-8 ">
                                    <input
                                        type="text"
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        id="staticEmail"
                                        disabled={!isEventOffSite}
                                        name="eventVenueName"
                                        value={eventFormData.eventVenueName || ''}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                    {errors.eventVenueName && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventVenueName}</div>}
                                </div>
                            </div>
                        </>
                    )}
                    {(!isEventOffSite) && (
                        <>
                            <div className="form-group row mb-2">
                                <label
                                    htmlFor="staticEmail"
                                    className="custom-font col-sm-4 col-form-label"
                                >
                                    EVENT VENUE ADDRESS
                                </label>
                                <div className="col-sm-8 ">
                                    <textarea
                                        type="text"
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        id="staticEmail"
                                        name="eventAddress"
                                        value={eventFormData.eventAddress || ''}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                        style={{ width: "95%" }}
                                    />
                                    {errors.eventAddress && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventAddress}</div>}
                                </div>
                            </div>
                        </>
                    )}
                    {(isEventOffSite) && (
                        <>
                            <div className="form-group row mb-2">
                                <label
                                    htmlFor="staticEmail"
                                    className="custom-font col-sm-4 col-form-label"
                                >
                                    EXTERNAL EVENT ADDRESS
                                </label>
                                <div className="col-sm-8 ">
                                    <textarea
                                        className="custom-font-lt form-control disabled"
                                        id="searchAddress"
                                        name="searchAddress"
                                        rows="5"
                                        value={searchAddress}
                                        onChange={handleSearchAddressChange}
                                        disabled={!isEditing}
                                    />
                                    {errors.eventAddress && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventAddress}</div>}
                                </div>
                            </div>
                        </>
                    )}

                </div>
                <div className=" bg-light rounded p-3 mt-3">

                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            EVENT TYPE
                        </label>
                        <div className="col-sm-8 " >

                            {isEditing ? (
                                <select className="custom-font-lt form-control form-select form-select-sm" aria-label="Small select example" name="eventType" value={eventFormData.eventType || ''} readOnly={!isEditing}
                                    onChange={handleInputChange}>
                                    <option value="">Select a Type</option>
                                    {eventType.map((eventType, index) => (
                                        <option key={index} value={eventType}>{eventType}</option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    className="custom-font-lt form-control-plaintext disabled"
                                    aria-label="Small select example"
                                    name="eventType"
                                    value={eventFormData.eventType || ''}
                                    readOnly={true}
                                />
                            )}
                            {errors.eventType && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventType}</div>}
                        </div>
                    </div>
                    {(eventFormData.eventType === "Other") && (
                        <>
                            <div className="form-group row mb-2" id="otherEventTypeAdminDiv">
                                <label
                                    htmlFor="staticEmail"
                                    className="border-custom-strip custom-font col-sm-4 col-form-label"
                                >
                                    <div className="" />
                                    {isEditing ? "PLEASE SPECIFY" : "SPECIFICATION"}
                                </label>
                                <div className="col-sm-8  ">
                                    <input
                                        type="text"
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        id="staticEmail"
                                        name="otherEventType"
                                        value={eventFormData.otherEventType || ''}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                    {errors.otherEventType && <div style={{ color: 'red', fontSize: "13px" }}>{errors.otherEventType}</div>}
                                </div>
                            </div>
                        </>
                    )}
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            EVENT FORMAT
                        </label>
                        <div className="col-sm-8 ">
                            {isEditing ? (
                                <select className="custom-font-lt form-control form-select form-select-sm" aria-label="Small select example" name="eventFormat" value={eventFormData.eventFormat || ''} readOnly={!isEditing}
                                    onChange={handleInputChange}>
                                    <option value="">Select a Format</option>
                                    {eventFormat.map((eventFormat, index) => (
                                        <option key={index} value={eventFormat}>{eventFormat}</option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    className="custom-font-lt form-control-plaintext disabled"
                                    aria-label="Small select example"
                                    name="eventFormat"
                                    value={eventFormData.eventFormat || ''}
                                    readOnly={true}
                                />
                            )}
                            {errors.eventFormat && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventFormat}</div>}
                        </div>
                    </div>
                    {(eventFormData.eventFormat === "Other") && (
                        <>
                            <div className="form-group row mb-2" id="otherEventFormatDiv">
                                <label
                                    htmlFor="staticEmail"
                                    className="border-custom-strip custom-font col-sm-4 col-form-label"
                                >
                                    <div className="" />
                                    {isEditing ? "PLEASE SPECIFY" : "SPECIFICATION"}
                                </label>
                                <div className="col-sm-8  ">
                                    <input
                                        type="text"
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        id="staticEmail"
                                        name="otherEventFormat"
                                        value={eventFormData.otherEventFormat || ''}
                                        readOnly={!isEditing}
                                        onChange={handleInputChange}
                                    />
                                    {errors.otherEventFormat && <div style={{ color: 'red', fontSize: "13px" }}>{errors.otherEventFormat}</div>}
                                </div>
                            </div>
                        </>
                    )}
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            LAST FAMILY MEMBER VISIT
                        </label>
                        <div className="col-sm-8 ">
                            {isEditing ? (
                                <select className="custom-font-lt form-control form-select form-select-sm" aria-label="Small select example" name="lastVisit" value={eventFormData.lastVisit || ''} readOnly={!isEditing}
                                    onChange={handleInputChange}>
                                    <option value="">Select a Range</option>
                                    {lastVisit.map((lastVisit, index) => (
                                        <option key={index} value={lastVisit}>{lastVisit}</option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    className="custom-font-lt form-control-plaintext disabled"
                                    aria-label="Small select example"
                                    name="lastVisit"
                                    value={eventFormData.lastVisit || ''}
                                    readOnly={true}
                                />
                            )}
                            {errors.lastVisit && <div style={{ color: 'red', fontSize: "13px" }}>{errors.lastVisit}</div>}
                        </div>
                    </div>

                </div>
                <div className=" bg-light rounded p-3 mt-3 mb-3">

                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            ASSOCIATE(S) EXPECTED AT EVENT
                        </label>
                        <div className="col-sm-8 " id="AssoInput">
                            {isEditing ? (
                                // Edit mode with checkboxes
                                associateAtEvent.map((associate, index) => (
                                    <div key={index}>
                                        <label className="form-check-label-custom form-check-label">
                                            <input
                                                type="checkbox"
                                                value={associate}
                                                className="form-check-input"
                                                name="associateAtEvent"
                                                checked={selectedAssociates.has(associate)}
                                                onChange={(e) => handleCheckboxChange(e, associate)}
                                            />
                                            {associate}
                                        </label>
                                        <br />
                                    </div>
                                ))
                            ) : (
                                // View mode with textarea
                                <textarea
                                    className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                    aria-label="Small select example"
                                    name="associates"
                                    rows="3"
                                    value={eventFormData.associates || ''} // Display selected associates as comma-separated values
                                    readOnly={true}
                                    onChange={handleInputChange}
                                    placeholder="Not Applicable"
                                    wrap="soft"
                                    style={{ resize: 'none' }}
                                />
                            )}
                        </div>
                    </div>
                    <div className="form-group row mb-2">
                        <label
                            htmlFor="staticEmail"
                            className="custom-font col-sm-4 col-form-label"
                        >
                            ESTIMATED TOTAL NUMBER OF ATTENDEES (NUMBERS ONLY)
                        </label>
                        <div className="col-sm-8 ">
                            <input
                                type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                                className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                id="staticEmail"
                                name="totalAttendees"
                                readOnly={!isEditing}
                                onChange={handleInputChange}
                                value={eventFormData.totalAttendees || ''}
                                placeholder="Not Applicable"
                            />
                            {errors.totalAttendees && <div style={{ color: 'red', fontSize: "13px" }}>{errors.totalAttendees}</div>}
                        </div>
                    </div>
                    <div className="form-group row mb-2 align-items-center editable">
                        <div className="col-sm-9 pr-0">
                            <input
                                type="text"
                                readOnly={true}
                                className="custom-font-lt form-control"
                                value={comments.EventSection || ''}
                                placeholder={!isEditing ? "" : "Leave a comment"}
                                onChange={(e) => { setComments({ ...comments, "EventSection": e.target.value }) }}
                            />
                        </div>
                        <div className="col-sm-3 pl-0">
                            <button type="button" className="buttonrequest btn btn-success ml-2"
                                onClick={(e) => { e.preventDefault(); addCommentsEventSection(); }}
                            >
                                SEND COMMENT
                            </button>
                        </div>
                    </div>
                    {Array.from(selectedAssociates).map((associate, index) => {
                        const apiName = associateMapping[associate];
                        return (
                            <div className="form-group row mb-4" key={index}>
                                <label
                                    htmlFor={`input-${index}`}
                                    className="custom-font col-sm-4 col-form-label bold-label"
                                >
                                    {`Estimated ${associate} Attendees`}
                                </label>
                                <div className="col-sm-8">
                                    <input
                                        type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                                        className={`custom-font-lt ${isEditing ? 'form-control' : 'form-control-plaintext disabled'}`}
                                        id={`inpat-${index}`}
                                        name={apiName}
                                        value={eventFormData[apiName] || ""}
                                        onChange={handleInputChange}
                                        placeholder={!isEditing ? "" : "Type an estimation"}
                                        readOnly={!isEditing}
                                    />
                                </div>
                                {errors[apiName] && <div style={{ color: 'red', fontSize: "13px" }}>{errors[apiName]}</div>}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="col-md-4 rounded " style={{pointerEvents:"none"}} id="MapID" >
                {/* <MapComponent style={{ height: "100vh", width: "100%" }} /> */}
            </div>
        </>
    );

    return content
}


export default EventAdmin;